module.exports = __webpack_public_path__ + "img/remark_08.f8d6b567.svg";